export const fetchWithAuthJson = async (url: string, options: RequestInit = {}) => {
    try{
        const response = await fetch(url, options);

        if(response.status === 403) {
            window.location.href = "/login";
            return null;
        }

        if(!response.ok) {
            const errorData = await response.json();
            throw new Error (errorData.message);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const fetchWithAuth = async (url: string, options: RequestInit = {}) => {
    try{
        const response = await fetch(url, options);

        if(response.status === 403) {
            window.location.href = "/login";
            return null;
        }

        if(!response.ok) {
            const errorData = await response.json();
            throw new Error (errorData.message);
        }

        return response;
    } catch (error) {
        throw error;
    }
};